import { ofType } from 'redux-observable';
import { map } from 'rxjs/operators/map';
import { switchMap } from 'rxjs/operators/switchMap';
import { catchError } from 'rxjs/operators/catchError';
import { types as actions, removeCategoryAction } from '../../reducers/actions';
import { CategoryService } from '../../services';
import { retryAuthentication } from '../../utils/epics/retryAuthentication';

export default function(action$, store) {
  return action$.pipe(
    ofType(actions.DELETE_CATEGORY),
    switchMap(action =>
      CategoryService.delete(action.category, store).pipe(
        map(() => removeCategoryAction(action.category)),
        catchError(retryAuthentication(action$, 'epics/categories/deleteCategory'))
      )
    )
  );
}



// WEBPACK FOOTER //
// ./src/epics/categories/deleteCategory.js